import React from "react";
import { useHistory } from "react-router-dom";
import urls from "../../global/constants/UrlConstants";

type MetaTheme = {
  iconBg: string;
  iconColor: string;
  footerBg: string;
  footerText: string;
  footerHover: string;
};

type MetaCard = {
  id: string;
  title: string;
  description: string;
  manageLabel: string;
  route: string;
  state?: Record<string, any>;
  theme: MetaTheme;
  icon: string;
  items: { label: string; icon: string; state?: Record<string, any>; route?: string }[];
};

const metaDataList: MetaCard[] = [
  {
    id: "1",
    title: "Department",
    description: "Manage your team metadata from this option.",
    manageLabel: "Manage Department",
    route: urls.metaListViewPath,
    state: { isAddDepartment: false, addDepartemnt: false },
    icon: "building",
    theme: {
      iconBg: "#F3E8FF",
      iconColor: "#A02448",
      footerBg: "#F3E8FF",
      footerText: "#6B1630",
      footerHover: "#F9F0F4",
    },
    items: [
      { label: "All Departments", icon: "list" },
      {
        label: "Add Department",
        icon: "plus",
        route: urls.ADDDEPARTMENTPAGE,
      },
      { label: "Department Head", icon: "user" },
      { label: "Department Settings", icon: "settings" },
    ],
  },
  {
    id: "2",
    title: "Locations",
    description: "Manage your project location.",
    manageLabel: "Manage Locations",
    route: urls.locationListViewPath,
    icon: "pin",
    theme: {
      iconBg: "#DBEAFE",
      iconColor: "#2563EB",
      footerBg: "#DBEAFE",
      footerText: "#1D4ED8",
      footerHover: "#BFDBFE",
    },
    items: [
      { label: "All Locations", icon: "list" },
      { label: "Add Location", icon: "plus" },
      { label: "Location Settings", icon: "settings" },
      { label: "Map View", icon: "map" },
    ],
  },
  {
    id: "2b",
    title: "Zones",
    description: "Organization-wise zone master for cities.",
    manageLabel: "Manage Zones",
    route: urls.metaProjectZonesListViewPath,
    icon: "pin",
    theme: {
      iconBg: "#FCE7F3",
      iconColor: "#BE185D",
      footerBg: "#FCE7F3",
      footerText: "#9D174D",
      footerHover: "#FBCFE8",
    },
    items: [
      { label: "All Zones", icon: "list" },
      { label: "Add Zone", icon: "plus" },
      { label: "Popular Zones", icon: "layers" },
      { label: "City Mapping", icon: "map" },
    ],
  },
  {
    id: "3",
    title: "Projects",
    description: "Manage Projects name & configurations.",
    manageLabel: "Manage Projects",
    route: urls.metaProjectListViewPath,
    icon: "briefcase",
    theme: {
      iconBg: "#D1FAE5",
      iconColor: "#059669",
      footerBg: "#D1FAE5",
      footerText: "#047857",
      footerHover: "#A7F3D0",
    },
    items: [
      { label: "All Projects", icon: "list" },
      { label: "Add Project", icon: "plus" },
      { label: "Project Types", icon: "layers" },
      { label: "Project Settings", icon: "settings" },
    ],
  },
  {
    id: "4",
    title: "Hierarchy",
    description: "Manage Company Hierarchy.",
    manageLabel: "Manage Hierarchy",
    route: urls.metaHierarchyListViewPath,
    state: { isAddHierarchy: false, addHierarchy: false },
    icon: "hierarchy",
    theme: {
      iconBg: "#FFEDD5",
      iconColor: "#EA580C",
      footerBg: "#FFEDD5",
      footerText: "#C2410C",
      footerHover: "#FED7AA",
    },
    items: [
      { label: "Company Structure", icon: "building" },
      { label: "Reporting Managers", icon: "users" },
      { label: "Hierarchy Levels", icon: "layers" },
      {
        label: "Hierarchy Settings",
        icon: "settings",
        state: { isAddHierarchy: true, addHierarchy: true },
      },
    ],
  },
  {
    id: "5",
    title: "Teams",
    description: "Manage Team name.",
    manageLabel: "Manage Teams",
    route: urls.metaTeamListViewPath,
    state: { isAddTeam: false, addTeam: false },
    icon: "users",
    theme: {
      iconBg: "#F9F0F4",
      iconColor: "#6B1630",
      footerBg: "#F9F0F4",
      footerText: "#5B21B6",
      footerHover: "#DDD6FE",
    },
    items: [
      { label: "All Teams", icon: "list" },
      {
        label: "Add Team",
        icon: "plus",
        state: { isAddTeam: true, addTeam: true },
      },
      { label: "Team Members", icon: "user" },
      { label: "Team Settings", icon: "settings" },
    ],
  },
  {
    id: "6",
    title: "Stage",
    description: "Manage your stage metadata from this option.",
    manageLabel: "Manage Stages",
    route: urls.metaStageListPath,
    state: { isAddStage: false, addStage: false },
    icon: "layers",
    theme: {
      iconBg: "#CCFBF1",
      iconColor: "#0D9488",
      footerBg: "#CCFBF1",
      footerText: "#0F766E",
      footerHover: "#99F6E4",
    },
    items: [
      { label: "All Stages", icon: "list" },
      {
        label: "Add Stage",
        icon: "plus",
        state: { isAddStage: true, addStage: true },
      },
      { label: "Stage Order", icon: "sliders" },
      { label: "Stage Settings", icon: "settings" },
    ],
  },
  {
    id: "7",
    title: "Project Filter",
    description: "Manage your project filter metadata from this option.",
    manageLabel: "Manage Filters",
    route: urls.metaProjectFilterListViewPath,
    icon: "funnel",
    theme: {
      iconBg: "#FCE7F3",
      iconColor: "#DB2777",
      footerBg: "#FCE7F3",
      footerText: "#BE185D",
      footerHover: "#FBCFE8",
    },
    items: [
      { label: "All Filters", icon: "list" },
      { label: "Add Filter", icon: "plus" },
      { label: "Filter Conditions", icon: "sliders" },
      { label: "Filter Settings", icon: "settings" },
    ],
  },
  {
    id: "8",
    title: "Location Meta",
    description: "Manage Project Location Meta.",
    manageLabel: "Manage Location Meta",
    route: urls.metaProjectLocationListViewPath,
    icon: "mapSettings",
    theme: {
      iconBg: "#F9F0F4",
      iconColor: "#4338CA",
      footerBg: "#F9F0F4",
      footerText: "#3730A3",
      footerHover: "#D4B8C0",
    },
    items: [
      { label: "Location Fields", icon: "list" },
      { label: "Add Field", icon: "plus" },
      { label: "Field Order", icon: "sliders" },
      { label: "Field Settings", icon: "settings" },
    ],
  },
  {
    id: "9",
    title: "CP Grades",
    description: "Channel Partner grade master (A, B, C…).",
    manageLabel: "Manage Grades",
    route: urls.metaGradeListPath,
    icon: "layers",
    theme: {
      iconBg: "#FEF3C7",
      iconColor: "#D97706",
      footerBg: "#FEF3C7",
      footerText: "#B45309",
      footerHover: "#FDE68A",
    },
    items: [
      { label: "All Grades", icon: "list" },
      { label: "Add Grade", icon: "plus" },
      { label: "Grade A / B defaults", icon: "layers" },
      { label: "Used in Channel Partners", icon: "settings" },
    ],
  },
  {
    id: "10",
    title: "Lead Sources",
    description: "Manage organization lead sources (Facebook, portals, walk-in…).",
    manageLabel: "Manage Sources",
    route: urls.metaLeadSourcesPath,
    icon: "funnel",
    theme: {
      iconBg: "#E0E7FF",
      iconColor: "#4338CA",
      footerBg: "#E0E7FF",
      footerText: "#3730A3",
      footerHover: "#C7D2FE",
    },
    items: [
      { label: "All Sources", icon: "list" },
      { label: "Add Source", icon: "plus" },
      { label: "Source groups", icon: "layers" },
      { label: "Used on forms & leads", icon: "settings" },
    ],
  },
];

const ItemIcon = ({ name }: { name: string }) => {
  const common = {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
  } as const;

  switch (name) {
    case "list":
      return (
        <svg {...common}>
          <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
        </svg>
      );
    case "plus":
      return (
        <svg {...common}>
          <path d="M12 5v14M5 12h14" />
        </svg>
      );
    case "user":
      return (
        <svg {...common}>
          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      );
    case "users":
      return (
        <svg {...common}>
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
        </svg>
      );
    case "settings":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9c.3.6.9 1 1.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" />
        </svg>
      );
    case "map":
      return (
        <svg {...common}>
          <path d="M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3V6z" />
          <path d="M8 3v15M16 6v15" />
        </svg>
      );
    case "layers":
      return (
        <svg {...common}>
          <path d="M12 2l9 5-9 5-9-5 9-5zM3 12l9 5 9-5M3 17l9 5 9-5" />
        </svg>
      );
    case "building":
      return (
        <svg {...common}>
          <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M15 9h.01M9 13h.01M15 13h.01M9 17h.01M15 17h.01" />
        </svg>
      );
    case "sliders":
      return (
        <svg {...common}>
          <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" />
        </svg>
      );
    case "funnel":
      return (
        <svg {...common}>
          <path d="M3 4h18l-7 8v6l-4 2v-8L3 4z" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="3" />
        </svg>
      );
  }
};

const HeaderIcon = ({
  type,
  color,
}: {
  type: string;
  color: string;
}) => {
  const common = {
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: 1.8,
  } as const;

  switch (type) {
    case "building":
      return (
        <svg {...common}>
          <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M15 9h.01M9 13h.01M15 13h.01M9 17h.01M15 17h.01" />
        </svg>
      );
    case "pin":
      return (
        <svg {...common}>
          <path d="M12 21s7-4.5 7-11a7 7 0 10-14 0c0 6.5 7 11 7 11z" />
          <circle cx="12" cy="10" r="2.5" />
        </svg>
      );
    case "briefcase":
      return (
        <svg {...common}>
          <rect x="2" y="7" width="20" height="14" rx="2" />
          <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2M2 13h20" />
        </svg>
      );
    case "hierarchy":
      return (
        <svg {...common}>
          <rect x="9" y="2" width="6" height="5" rx="1" />
          <rect x="2" y="17" width="6" height="5" rx="1" />
          <rect x="16" y="17" width="6" height="5" rx="1" />
          <path d="M12 7v4M5 13v4M19 13v4M5 13h14" />
        </svg>
      );
    case "users":
      return (
        <svg {...common}>
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
        </svg>
      );
    case "layers":
      return (
        <svg {...common}>
          <path d="M12 2l9 5-9 5-9-5 9-5zM3 12l9 5 9-5M3 17l9 5 9-5" />
        </svg>
      );
    case "funnel":
      return (
        <svg {...common}>
          <path d="M3 4h18l-7 8v6l-4 2v-8L3 4z" />
        </svg>
      );
    case "mapSettings":
      return (
        <svg {...common}>
          <path d="M12 21s7-4.5 7-11a7 7 0 10-14 0c0 6.5 7 11 7 11z" />
          <circle cx="12" cy="10" r="2.5" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
        </svg>
      );
  }
};

const MetaData = () => {
  const history = useHistory();

  const goTo = (route: string, state?: Record<string, any>) => {
    history.push(route, state || {});
  };

  return (
    <div className="h-full min-h-0 overflow-auto bg-white p-4 sm:p-6 lg:p-8 [scrollbar-width:thin]">
      <div className="mb-6">
        <h1 className="text-2xl font-bold tracking-tight text-[#1E1B4B] sm:text-[32px] sm:leading-tight">
          Meta Data
        </h1>
        <p className="mt-1.5 text-sm text-[#6B7280] sm:text-[15px]">
          Manage your metadata here
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {metaDataList.map((item) => (
          <div
            key={item.id}
            className="flex flex-col rounded-2xl border border-[#EEF0F5] bg-white p-5 shadow-[0_4px_20px_rgba(15,23,42,0.04)] transition hover:shadow-[0_8px_28px_rgba(15,23,42,0.07)]"
          >
            <div className="mb-4 flex items-start gap-3">
              <span
                className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full"
                style={{ backgroundColor: item.theme.iconBg }}
              >
                <HeaderIcon type={item.icon} color={item.theme.iconColor} />
              </span>
              <div className="min-w-0">
                <h2 className="text-[15px] font-bold text-[#111827]">
                  {item.title}
                </h2>
                <p className="mt-1 text-[12px] leading-relaxed text-[#6B7280]">
                  {item.description}
                </p>
              </div>
            </div>

            <ul className="mb-5 flex flex-1 flex-col gap-3">
              {item.items.map((row) => (
                <li key={row.label}>
                  <button
                    type="button"
                    onClick={() =>
                      goTo(row.route || item.route, row.state || item.state || {})
                    }
                    className="flex w-full items-center gap-2.5 text-left text-[13px] text-[#374151] transition hover:text-[#A02448]"
                  >
                    <span className="text-[#9CA3AF]">
                      <ItemIcon name={row.icon} />
                    </span>
                    {row.label}
                  </button>
                </li>
              ))}
            </ul>

            <button
              type="button"
              onClick={() => goTo(item.route, item.state || {})}
              className="mt-auto inline-flex h-11 w-full items-center justify-between rounded-xl px-4 text-sm font-semibold transition"
              style={{
                backgroundColor: item.theme.footerBg,
                color: item.theme.footerText,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = item.theme.footerHover;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = item.theme.footerBg;
              }}
            >
              <span>{item.manageLabel}</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetaData;
